import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  EnterpriseConfigurationDataAccessService,
  IEnterpriseConfiguration,
  IHelp,
} from '../../shared/modules/enterprise-configuration/enterprise-configuration-data-access.service';

@Component({
  selector: 'app-help-menu',
  templateUrl: './help-menu.component.html',
  styleUrls: ['./help-menu.component.scss'],
})
export class HelpMenuComponent {
  public helpMenuItems$: Observable<IHelp[]>;
  public contactTechnicalSupportUrl: string | undefined;
  public contactTechnicalSupportText: string | undefined;
  public contactSalesAnchorText: string | undefined;
  public contactSalesAnchorUrl: string | undefined;
  public contactSupportHomeAnchorText: string | undefined;
  public contactSupportHomeAnchorUrl: string | undefined;
  private _enterpriseConfiguration$: Observable<IEnterpriseConfiguration>;

  constructor(_enterpriseConfigurationService: EnterpriseConfigurationDataAccessService) {
    this._enterpriseConfiguration$ = _enterpriseConfigurationService.getEnterpriseConfiguration();
    this.helpMenuItems$ = this._enterpriseConfiguration$.pipe(
      map((config) => {
        return config.helpGuides;
      }),
    );
    _enterpriseConfigurationService.getEnterpriseConfiguration().subscribe((config) => {
      this.contactTechnicalSupportText = config.technicalSupportAnchorText;
      this.contactTechnicalSupportUrl = config.contactSupportAnchorUrl;
      this.contactSalesAnchorText = config.contactSalesAnchorText;
      this.contactSalesAnchorUrl = config.contactSalesAnchorUrl;
      this.contactSupportHomeAnchorText = config.contactSupportAnchorText;
      this.contactSupportHomeAnchorUrl = config.contactSupportAnchorUrl;
    });
  }
}
